<template>
  <base-page-component :has-nav="false">
    <div class="o-y-auto noscroll" style="background-color: #f5f7f9;height:calc(100% - 44px) ">
      <div class="m-auto flex" style="width: 1114px">
        <div class="bg-white flex-shrink-0 "
             style="width: 182px;margin-right: 8px;min-height: 800px">
          <div class="p-h-5 p-v-20" style="position: sticky;top: 0">
            <div class="p-h-15 flex a-center j-between">
              <span class="fs-16 bold">案例</span>
              <span @click="onBackClick" class="p-h-7"
                    style="cursor: pointer;color: #4B8AFF;border:1px solid #4B8AFF;border-radius: 12px">返回案例库</span>
            </div>
            <ul>
              <!--<li :key="index" @click="onCaseCreateClick" class="flex a-center j-center p-v-10 hoverStyle fs-14 p-l-15"-->
              <!--style="color: #333">-->
              <!--<div class="flex-1" style="cursor: pointer;">-->
              <!--<span class="">●</span>-->
              <!--<span class="m-l-10">新增案例</span>-->
              <!--</div>-->
              <!--</li>-->
              <li :key="index" @click="groupManager.show = true"
                  class="flex a-center j-center p-v-10 hoverStyle fs-14 p-l-15"
                  style="color: #333">
                <div class="flex-1" style="cursor: pointer;">
                  <span class="">●</span>
                  <span class="m-l-10">分类管理</span>
                </div>
              </li>
              <li :key="index" :style="{color:getbgColor(item)}" @click="onTypeItemSelect(item)"
                  class="flex a-center j-center p-v-10 hoverStyle fs-14 p-l-15"
                  v-for="(item,index) in typeList">
                <div class="flex-1" style="cursor: pointer;">
                  <span :style="{visibility: getStyleVisibility(item)}" class="">●</span>
                  <span class="m-l-10">{{ item.name }}</span>
                </div>
              </li>
            </ul>
            <!--<div class="p-h-15 m-v-10 flex a-center">-->
            <!--&lt;!&ndash;<span @click="createExample" class="fs-16 bold" style="cursor: pointer">新增案例</span>&ndash;&gt;-->

            <!--</div>-->
          </div>
        </div>
        <div class="flex" style="width: 932px">
          <div class="flex-shrink-0 relative" style="width: 642px;height: calc(100% - 40px)">
            <div class="h-full ">
              <ul>
                <li class="bg-white flex a-center p-h-20"
                    style="height: 44px;position: sticky;top: 0;z-index: 1001;border-bottom: 1px solid #f9f9f9">
                  <span class="fs-16 bold">{{ proName }}</span>
                  <span class="flex-1"></span>
                  <Button @click="onCaseCreateClick" type="primary">新增案例</Button>
                </li>
                <li :key="index" class="m-v-10 bg-white" v-for="(item,index) in dataList">
                  <div class="text-left fs-14 p-h-10">
                    <div class="flex a-top p-t-10">
                      <img :src="getUserImg(item)" alt="" class="b-round m-r-5 flex-s-0"
                           style="width: 44px;height: 44px">
                      <div class="flex-1 m-l-5 p-t-5">
                        <div v-if="getUserName(item)">
                          <div>{{ getUserName(item) }}</div>
                          <div>{{ item.publishTime }}</div>
                        </div>
                        <img class="w-full" src="../../../assets/common/ic_text_sec.png"
                             v-if="!getUserName(item)">
                      </div>
                      <div>
                        <Dropdown :transfer="true" @on-click="handleDrop($event, item,index)"
                                  class="fileListDrop"
                                  placement="bottom-end"
                                  trigger="click">
                          <img alt="" src="../../../assets/common/ic_more_bg_hover.png"
                               style="width: 28px;height: 28px;cursor: pointer">
                          <DropdownMenu slot="list">
                            <DropdownItem class="DropdownItem" name="top" v-if="!item.isTop">置顶
                            </DropdownItem>
                            <DropdownItem class="DropdownItem" name="unTop" v-if="item.isTop">取消置顶
                            </DropdownItem>
                            <DropdownItem class="DropdownItem" name="edit">编辑</DropdownItem>
                            <DropdownItem class="DropdownItem" name="delete">删除</DropdownItem>
                          </DropdownMenu>
                        </Dropdown>
                      </div>
                    </div>
                    <div style="padding-left: 50px">
                      <div class="m-v-5 bold" v-if="item.title">
                        <span>{{ item.title }}</span>
                      </div>
                      <div class="m-v-5 bold" v-if="item.content">
                        <span v-html="getItemContent(item)"></span>
                        <span
                          v-if="item.content.length>80 && item.extend === false"><span>...</span><span
                          @click="item.extend=true" style="color: #3B80FF;cursor: pointer">展开</span></span>
                        <span v-if="item.content.length>80 && item.extend === true">
                        <span @click="item.extend=false"
                              style="color: #3B80FF;cursor: pointer">收起</span>
                      </span>
                      </div>
                      <div class="relative left-0 top-0" v-if="getShowVideoPic(item)"
                      >
                        <img :src="getShowVideoPic(item)" @click.stop="play(item)" alt="" class="w-full"
                             style="width: 50%">
                        <div
                          @click.stop="play(item)"
                          class="h-full absolute top-0 flex a-center j-center h-full"
                          style="width: 50%">
                          <img class="w-40 h-40" src="../../../assets/common/ic_shipin_play.png">
                        </div>
                      </div>
                      <ul class="flex flex-wrap" v-if="item.imgList && item.imgList.length>0">
                        <li :key="index_child" :style="{width:getItemWidth(item.imgList.length)}"
                            class=" p-4 fs-s-0"
                            v-for="(item_child,index_child) in item.imgList.slice(0,6)">
                          <div class="flex a-center j-center border"
                               style="background: #F8F8F9;width: 40%"
                               v-if="item.imgList.length === 1">
                            <img style="object-fit: cover"
                                 @click="preview(item_child)"
                                 :src="$getFomatUrl(getShowImg(item_child),600)" alt="" class="w-full h-full">
                          </div>

                          <ratio-div :RadioValue="82" v-if="item.imgList.length===2">
                            <div
                              class="w-full h-full absolute top-0 left-0 flex a-center j-center border"
                              style="background: #F8F8F9">
                              <img style="object-fit: cover"
                                   @click="preview(item_child)"
                                   :src="$getFomatUrl(getShowImg(item_child),600)" alt="" class="w-full h-full"
                                   v-if="item_child.imgUrl">
                            </div>
                          </ratio-div>
                          <ratio-div :RadioValue="100" v-if="item.imgList.length>2">
                            <div
                              class="w-full h-full absolute top-0 left-0 flex a-center j-center border"
                              style="background: #F8F8F9">
                              <img style="object-fit: cover"
                                   @click="preview(item_child)"
                                   :src="$getFomatUrl(getShowImg(item_child),600)" alt="" class="w-full h-full"
                                   v-if="item_child.imgUrl">
                              <div
                                class="absolute w-full h-full left-0 top-0 flex a-center j-center fs-30 bold text-white"
                                style="background: #00000040"
                                v-if="item.imgList.length>6 && index_child===5">
                                <span>+</span> <span
                                class="m-l-5">{{ item.imgList.length - 6 }}</span>
                              </div>
                            </div>
                          </ratio-div>
                        </li>
                      </ul>
                      <div class="m-t-10 flex a-center" v-if="getshowGroup(item)">
                        <img src="../../../assets/common/ic_group.png"
                             style="width: 14px;height: 14px;">
                        <div class="m-l-5 fs-12" style="color: #417BE3">
                          {{ getshowGroup(item) }}
                        </div>
                      </div>
                      <div class="m-t-5 flex a-center" v-if="getshowAddress(item)">
                        <img src="../../../assets/common/ic_dizhi_address.png"
                             style="width: 14px;height: 14px;">
                        <div class="m-l-5 fs-12" style="color: #417BE3">
                          {{ getshowAddress(item) }}
                        </div>
                      </div>

                      <div class="m-t-5 flex a-center" v-if="getshowLinkGood(item)">
                        <img src="../../../assets/common/ic_link.png"
                             style="width: 14px;height: 14px;">
                        <div class="m-l-5 fs-12" style="color: #417BE3;cursor: pointer">
                          {{ getshowLinkGood(item) }}
                        </div>
                      </div>

                      <div class="flex h-40">
                        <div class="flex a-center h-full" style="width: 33.3%">
                          <img src="../../../assets/common/ic_read.png"
                               style="width: 18px;height: 18px;">
                          <span class="m-l-5">{{ item.readCount || '' }}</span>
                        </div>
                        <div class="flex a-center h-full" style="width: 33.3%">
                          <img src="../../../assets/common/ic_likes.png"
                               style="width: 18px;height: 18px;">
                          <span class="m-l-5">{{ item.praiseCount || '' }}</span>
                        </div>
                        <div class="flex a-center h-full" style="width: 33.3%">
                          <img @click="onCommentClick(item)"
                               src="../../../assets/common/ic_remark.png"
                               style="width: 18px;height: 18px;cursor: pointer">
                          <span @click="onCommentClick(item)" class="m-l-5" style="cursor: pointer">{{ item.commentCount || '' }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
              <infinite-loading :distance="10" :identifier="selTypeId"
                                @infinite="infiniteHandler"
                                ref="infiniteLoading">
                <div class="total"
                     slot="no-more">
                </div>
                <div slot="no-results"></div>
              </infinite-loading>
            </div>
            <!--<img @click="onCaseCreateClick" alt="" src="../../../assets/common/ic_blue_add.png"-->
            <!--style="width: 48px;height: 48px;cursor: pointer;position: absolute;right: 15px;bottom: 40px">-->
          </div>
          <div class="flex-shrink-0" style="width: 282px;margin-left: 8px;background-color: white">
            <div class="bg-white p-b-1" style="position: sticky;top: 0;min-height: 200px">
              <div class="b-b flex p-h-10 a-center" style="height: 40px">
                <span class="fs-14 bold">商品案例</span>
              </div>
              <ul class="p-h-10">
                <li :key="index" class="m-v-10 flex a-center" v-for="(item,index) in productList">
                  <div class="fs-14">{{ index + 1 }}</div>
                  <div @click="onProductClick(item)" class="m-l-5" style="cursor: pointer">
                    {{ item.name }}
                  </div>
                  <div class="flex-1"></div>
                  <div>

                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Modal
      :closable="false"
      class="modal-setting"
      class-name="vertical-center-modal"
      v-model="groupManager.show"
      width="640px"
    >
      <p class="text-center" slot="header">
        <span>{{ groupManager.title }}</span>
      </p>

      <div class="flex a-center j-center" style="width: 600px;height: 360px">
        <class-group-setting-widget2 :objInfo="objInfo" :open="groupManager.show"
                                     :srcType="8"
                                     class="w-full h-full">
        </class-group-setting-widget2>
      </div>
    </Modal>
    <example-modal
      :on-ok="exampleModalOnOk"
      ref="exampleModal"/>

    <Modal
      @on-visible-change="onVideoPrewModalClose"
      class-name="vertical-center-modal"
      footer-hide
      v-model="showVideoPrew"
      width="650">
      <video-prew :videoinfo="videoprewinfo" ref="prewplayer"/>
    </Modal>
    <!--图片预览-->
    <Modal :closable="true" class="modal-setting" class-name="vertical-center-modal" footer-hide title=""
           v-model="previewModal.show"
           width="650">
      <p class="text-center" slot="header">
        <span>{{ previewModal.title }}</span>
      </p>
      <div class="p-h-10 p-b-10 o-y-auto"
           style="min-height: 200px;max-height: 600px">
        <img :onerror="loadImgError"
             :src="previewModal.picUrl?previewModal.picUrl:require('../../../assets/common/ic_wutu@2x.png')"
             style="width: 100%">
      </div>
    </Modal>
  </base-page-component>
</template>
<script>
import {mapActions, mapMutations} from 'vuex'
import BasePageComponent from '../../../components/common/BasePageComponent'
import RatioDiv from '../../../components/common/RatioDiv'
import classGroupSettingWidget2 from '@/components/common/ClassGroupSettingWidget2'
import Bus from '../../../utils/bus'
import ExampleModal from '@/views/material/example/ExampleModal'
import VideosPrew from '@/components/common/VideosPrew'
import VideoPrew from '@/components/common/VideoPrew'

export default {
  name: 'GoodsCase',
  components: {
    VideoPrew,
    VideosPrew,
    ExampleModal,
    RatioDiv,
    BasePageComponent,
    classGroupSettingWidget2
  },
  data () {
    return {
      pid: 0,
      proName: '',
      tablePage: {                               //表格分页
        total: 0,
        currentPage: 1,
        pageSize: 30,
      },
      objChange: {                               //分类分组帅选
        classId: 0,
        groupId: 0,
        linkurl: ''
      },
      objInfo: {
        classId: 0,
        className: '',
        groupId: 0,
        groupName: '',
        init: false
      },
      groupManager: {
        title: '分类管理',
        show: false,
      },
      typeList: [],
      dataList: [],
      productList: [],
      selTypeId: 0,
      fun: null,

      //视频预览
      showVideoPrew: false,
      videoprewinfo: {       //预览参数
        videoAliVid: '',
        videoUrl: '',
        coverUrl: '',
        videoTitle: ''
      },
      previewModal: {
        title: '',
        show: false,
        picUrl: '',
      },
      loadImgError: 'this.src="' + require('../../../assets/common/ic_wutu@2x.png') + '"',
    }
  },
  computed: {},
  watch: {
    '$route.query.proId': {
      handler (newValue) {
        if (this.$route.query.proId) {
          if (this.pid !== parseInt(this.$route.query.proId || 0)) {
            this.pid = parseInt(this.$route.query.proId || 0)
            this.objChange = {
              classId: 0,
              groupId: 0,
              linkurl: ''
            }
            this.getProDetails()
            this.tablePage.currentPage = 1
            this.dataList = []
            this.selTypeId = -1
            this.$nextTick(() => {
              this.tablePage.currentPage = 1
              this.dataList = []
              this.selTypeId = 0
            })
          }
        }

      },
      immediate: true
    }
  },
  // activated () {
  //   this.tablePage.currentPage = 1
  //   this.objChange = {
  //     classId: 0,
  //     groupId: 0,
  //     linkurl: ''
  //   }
  //   this.dataList = []
  //   this.selTypeId = -1
  //   this.$nextTick(() => {
  //     this.tablePage.currentPage = 1
  //     this.dataList = []
  //     this.selTypeId = 0
  //   })
  // },
  mounted () {
    this.init()
    this.fun = (e) => {
      if (parseInt(e.type) === 8) {
        this.formatCaseTypeList()
        if (parseInt(e.changeType === 13) && this.selTypeId === parseInt(e.changeId)) {
          this.dataList = []
          this.tablePage.currentPage = 1
          this.objChange = {
            classId: 0,
            groupId: 0,
            linkurl: ''
          }
          this.selTypeId = 0
        }
      }
    }
    Bus.$on('cgChange', this.fun)
  },
  destroyed () {
    Bus.$off('cgChange', this.fun)
  },
  methods: {
    async formatCaseTypeList () {
      let caseTypeList = await this.getClassList()
      this.typeList = [{
        id: 0,
        name: '全部分类'
      }, ...caseTypeList]
    },
    async init () {
      await this.formatCaseTypeList()
      this.onGetGoods()
    },

    infiniteHandler ($state) {
      this.$nextTick(() => {
        this.getBBsLists($state)
      })
    },

    getProDetails () {
      if (!this.pid) {
        return
      }
      this.getGoodDetail(this.pid).then(res => {
        if (res.code === 0) {
          this.proName = res.data.name || ''
        }
      })
    },
    getClassList () {
      return new Promise((resolve, reject) => {
        let params = {
          type: 8,
        }
        this.getCategoryLists(params).then((res) => {
          if (res.code === 0) {
            let arr = res.data
            resolve(arr)
          }
        })
      })
    },
    onGetGoods () {
      let params = {
        pageSize: 10,
        pageNum: 1
      }
      this.getGoods(params).then(res => {
        if (res.code === 0) {
          this.productList = res.data.list.map(child => {
            child.url = child.link ? child.link.link || '' : ''
            return child
          })
        }
      })
    },
    /**
     * 获取动态列表
     * */
    getBBsLists ($state) {
      if (!this.pid) {
        return
      }
      let params = {
        pageSize: this.tablePage.pageSize,
        pageNum: this.tablePage.currentPage,
        goodsId: this.pid
      }
      if (this.title) {
        params.title = this.title
      }
      if (this.objChange && this.objChange.classId) {
        params.categoryId = this.objChange.classId
      }
      if (this.objChange && this.objChange.groupId) {
        params.groupId = this.objChange.groupId
      }

      this.getbbslist(params).then(res => {
        if (res.code === 0) {
          let list = res.data.list.map(child => {
            child.username = child.user ? child.user.name || '' : ''
            child.url = child.link ? child.link.link || '' : ''
            child.extend = false
            return child
          })
          if (this.tablePage.currentPage === 1) {
            this.dataList = list
          } else {
            this.dataList = this.dataList.concat(list)
          }
          if (list && list.length < 1) {
            $state.complete()
          } else {
            this.tablePage.currentPage++
            this.$nextTick(() => {
              $state.loaded()
            })
          }
          this.tablePage.total = res.data.total || 0
        }
      })

    },
    getUserImg (item) {
      if (item && item.user && item.user.icon) {
        return item.user.icon
      }
      return require('../../../assets/common/ic_head_portrait.png')
    },
    getUserName (item) {
      if (item && item.user && item.user.name) {
        return item.user.name
      }
      return ''
    },
    getShowImg (item) {
      if (item.imgUrl) {
        return item.imgUrl
      }
      return require('../../../assets/common/ic_picture_center.png')
    },
    getShowVideoPic (item) {
      let videoCover = ''
      if (item.videoList && item.videoList.length) {
        let videoItem = item.videoList[0]
        if (videoItem.imgUrl) {
          return videoItem.imgUrl
        }
        if (videoItem.videoUrl) {
          return videoItem.videoUrl + '?x-oss-process=video/snapshot,t_1000,ar_auto'
        }
      }
      return videoCover
    },
    getshowGroup (item) {
      let str = ''
      if (item && item.groupName) {
        str = item.groupName
      } else if (item && item.categoryName) {
        str = item.categoryName
      } else {
        str = '案例'
      }
      return str
    },
    getshowAddress (item) {
      let str = ''
      if (item && item.location) {
        let location = item.location
        let prov = location.prov || ''
        let city = location.city || ''
        let dist = location.dist || ''

        let prefix = prov + city
        if (dist) {
          if (prefix) {
            str = prefix + '·' + dist
          } else {
            str = dist
          }
        }
      }
      return str
    },
    getshowLinkGood (item) {
      let str = ''
      if (item.goodsList && item.goodsList.length) {
        str = item.goodsList.map(res => {
          return res.name
        }).join(',')
      }
      return str
    },
    onTypeItemSelect (item) {
      if (this.selTypeId !== item.id) {
        this.objChange.classId = item.id
        this.tablePage.currentPage = 1
        this.dataList = []
        this.$nextTick(() => {
          this.selTypeId = item.id
        })
      }
    },
    getbgColor (item) {
      if (item.id === this.selTypeId) {
        return '#4B8AFF'
      } else {
        return '#333'
      }
    },
    getItemWidth (len) {
      let dWidth = '33.3%'
      switch (len) {
        case 1:
          dWidth = '100%'
          break
        case 2:
          dWidth = '50%'
          break
        default:
          break
      }
      return dWidth
    },
    getItemContent (item) {
      let content = item.content
      if (content.length > 80) {
        if (item.extend === false) {
          content = item.content.slice(0, 80)
        }
      }
      return content
    },
    onProductClick (item) {
      this.$router.push({
        path: '/goodscase',
        query: {
          proId: item.id
        }
      })
    },
    onCaseCreateClick () {
      // this.$router.push({
      //   path: '/materialnewexample',
      //   query: {
      //     id: this.pid,
      //     name: this.proName
      //   }
      // })
      // this.$refs.newExampleModal.show(this.pid,this.proName)
      let classId = this.selTypeId
      if (classId === 0) {   //当前选择了全部时, 弹框默认选择 默认分类
        let item = this.typeList.find(item => item.isDefault === 1)
        if (item)
          classId = item.id
      }
      let params = {
        categoryId: classId, //分类id
        type: 8                     //srcType
      }
      //查找该分类下的默认分组
      this.getGroupLists(params).then(res => {
        let groupId = 0
        if (res.code === 0) {
          if (res.data && res.data.length) {
            let groupList = res.data
            let item = groupList.find(item => item.isDefault === 1)
            if (item)
              groupId = item.id
          }
        }
        this.$refs.exampleModal.showCreate(classId, groupId, this.pid, this.proName)
      })
    },
    onCommentClick (item) {
      this.$router.push({
        path: '/casedetail',
        query: {
          caseId: item.id
        }
      })
    },
    handleDrop (name, row, index) {
      if (name === 'delete') {
        this.delItem(row, index)
      } else if (name === 'edit') {
        this.editExample(row)
      } else if (name === 'top') {
        let params = {
          id: row.id,
          isTop: 1
        }
        this.bbsTop(params).then(res => {
          this.tablePage.currentPage = 1
          this.getBBsLists()
        })
      } else if (name === 'unTop') {
        let params = {
          id: row.id,
          isTop: 0
        }
        this.bbsTop(params).then(res => {
          this.tablePage.currentPage = 1
          this.getBBsLists()
        })
      }
    },
    editExample (row) {
      // this.$router.push({
      //   path: '/materialeditexample',
      //   query: {
      //     caseId: row.id
      //   }
      // })
      console.log('-------------------row----------------------------------')
      console.log(row)
      console.log('-----------------------------------------------------')
      this.$refs.exampleModal.showEdit(row)
    },
    delItem (item, index) {
      const content = '<p>确定要删除吗?</p>'
      this.$Modal.confirm({
        title: '提示',
        content: content,
        onOk: () => {
          let params = {}
          let id = item.id
          this.delBbs({
            id,
            params
          }).then(res => {
            if (res.code === 0) {
              // this.getBBsLists()
              this.dataList.splice(index, 1)
            }
            if (res.msg) {
              this.$Message.success(res.msg)
            }
          })
        },
        onCancel: () => {
        }
      })
    },

    /**
     * 创建案例成功,刷新页面
     */
    exampleModalOnOk () {
      if (this.$refs.exampleModal.modalType === 'create') {
        this.tablePage.currentPage = 1
        this.dataList = []
        let tmp = this.selTypeId
        this.selTypeId = -1
        this.$nextTick(() => {
          this.tablePage.currentPage = 1
          this.dataList = []
          this.selTypeId = tmp
        })
      } else {

      }
    },
    onVideoPrewModalClose (status) {
      if (!status) {
        this.videoprewinfo = {
          videoUrl: '',
          videoAliVid: '',
          coverUrl: '',
          videoTitle: ''
        }
      }
    },
    play (data) {
      if (data.videoList && data.videoList.length) {
        let item = data.videoList[0]
        if (item.sourceUrl || item.videoAliVid || item.videoUrl) {
          this.videoprewinfo = {
            videoUrl: item.sourceUrl || item.videoUrl || '',
            videoAliVid: item.videoAliVid || '',
            coverUrl: item.coverImgUrl,
            videoTitle: item.title
          }
          this.showVideoPrew = true
        }
      }
    },
    getStyleVisibility (item) {
      let visibility = 'hidden'
      if (item.id < 1) {
        visibility = 'visible'
      }
      return visibility
    },
    onBackClick () {
      this.$router.push({
        path: '/examplerepository'
      })
    },
    /**
     * 图片预览
     * @param row
     */
    preview (row) {
      this.previewModal.title = row.title || '图片预览'
      this.previewModal.picUrl = row.imgUrl
      this.previewModal.show = true
    },

    ...mapMutations([
      'closeTag'
    ]),
    ...mapActions([
      'getbbslistbyPro',
      'getGoods',
      'getCategoryLists',
      'getGoodDetail',
      'delBbs',
      'getbbslist',
      'getGroupLists',
      'bbsTop'
    ])
  }
}
</script>

<style lang="scss" scoped>
  .hoverStyle:hover {
    background-color: #f2f2f2;
  }
  .modal-setting ::v-deep {
    //标题背景色
    .ivu-modal-header {
      background-color: #e7e9eD;
      margin-bottom: 10px;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
    }

    .ivu-modal-body {
      padding: 0;
      display: flex;
      justify-content: center;
      align-content: center;
    }

    //标题下横线
    .ivu-modal-header {
      border-bottom: none;
    }

    //确认取消按钮上面红线
    .ivu-modal-footer {
      border-top: none;
      //取消padding margin
      //padding: 0;
      //margin: 0;
    }
  }
</style>
